import { useFlightStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreFlightsComponent,
  type FareClassOptionFilter,
} from "@b2bportal/core-types";
import { CheckboxGroup } from "@b2bportal/core-ui";
import { useFareClassOptions } from "@tenant/flights";
import defaultStyles from "./FilterFareClass.module.scss";

export interface FilterFareClassComponentProps {
  fareClasses: FareClassOptionFilter;
  onFareClassChange: (fareClasses: FareClassOptionFilter) => void;
}
export const FilterFareClass = ({
  fareClasses,
  onFareClassChange,
}: FilterFareClassComponentProps) => {
  const COMPONENT_KEY = CoreFlightsComponent.FilterFareClass;
  const styles = useFlightStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const {
    context: { fareClassOptions },
  } = useFareClassOptions();

  // filter out checked options by strictly equaling to true
  const checkedOptions: string[] = Object.keys(fareClasses).filter(
    (f) => fareClasses[f] === true
  );
  return (
    <div className={block}>
      <CheckboxGroup
        checkedOptions={checkedOptions}
        options={fareClassOptions}
        onOptionClick={(option) => {
          onFareClassChange({
            ...fareClasses,
            [option]: !fareClasses[option],
          });
        }}
      />
    </div>
  );
};
